import usePluginHandler from '../../../hooks/usePluginHandler';
import { isCalledByParent } from '../../../models/caller';
import { PluginMessageTypes } from '../../../models/constants';
import MessagesPlugin from '../../../models/messages';

const messageHandler = (message) => {
  if (message.type === PluginMessageTypes.CALL_FORWARD) {
    const {
      type, callId,
    } = message.payload;
    // gestione della chiamata per la get url browser
    if (type === PluginMessageTypes.GET_ROOT_LOCATION) {
      // se l'applicazione attuale è caricata in un altro plugins, allora inoltro la richiesta al parent
      if (isCalledByParent()) {
        MessagesPlugin.forwardMessageToParent(message);
      } else {
        const { href } = window.location;
        MessagesPlugin.postMessageToChilds(
          PluginMessageTypes.CALL_FORWARD_RESPONSE,
          { callId, response: { href } },
        );
      }
    }
  }
};

/**
 * Gestisce la richiesta di url del browser
 */
export default function useRootLocation() {
  usePluginHandler(messageHandler);
}
